import React from 'react';
import PropTypes from 'prop-types';

import { PhotoProduct } from 'components/Product';

const OrderGallery = ({ products }) => {
    const productsLength = products.length;
    return (
        <div className="order__gallery">
            {products.map((item, index) => {
                return (
                    index < 3 && (
                        <PhotoProduct
                            key={`product-${index}`}
                            photos={item.photos}
                            uuid={item.id}
                            productsLength={productsLength}
                        />
                    )
                );
            })}
        </div>
    );
};

OrderGallery.propTypes = {
    products: PropTypes.array.isRequired,
};

export default OrderGallery;
